module.exports = __webpack_public_path__ + "static/media/share.8ccc070b.svg";